import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as bootstrap from "bootstrap";
import "../../assets/css/mainMenu.css";
import "../../assets/css/addunit.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import edit from "../../assets/icons/edit.svg";
import close from "../../assets/icons/close.svg";
import visible from "../../assets/icons/visible 1.svg";
// import download from "../../assets/icons/lucide_download.svg";
import download from "../../assets/icons/bxs-file-json.svg";
import Compactyml from "../../assets/icons/Compact_YML.svg"
import downloadwhite from "../../assets/icons/lucide_download_white.svg";

// import btn3 from "../../assets/icons/analytic.svg";
import btn3 from "../../assets/icons/YML.svg";


import ArrowDown from "../../assets/icons2/ArrowDown.svg";
import ArrowUp from "../../assets/icons2/ArrowUp.svg";

import plus1 from "../../assets/icons/plus1.svg";
import search2 from "../../assets/icons/search2.svg";

import Loader from "../../Components/LoaderAndSpinner/Loader";
import { useDispatch } from "react-redux";
import { fetchMenuItems } from "../../Redux/Menu/MenuSlice";

import trash from "../../assets/icons/trash.svg";
import fetchWrapper from "./../../AuthMiddleware/FetchWrapper";

import Pagination from "../../Components/Pagination/Pagination";
import { hasPermission } from "../../Services/authUtils";

const AllAssets = () => {

  const [assetname, setAssetname] = useState("");
  const [tooltipid, setTooltipid] = useState(null);
  const buttonRef = useRef(null);

  const [isOpen, setIsOpen] = useState(false);
  const [filteredAssets, setFilteredAssets] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const dropdownRef = useRef(null);
  const searchInputRef = useRef(null);

  const [deleteid, setDeleteid] = useState("");
  const [asset_id, setAsset_Id] = useState(null);
  // const [dynamicColumns, setDynamicColumns] = useState([]);
  const [assetAttribute, setAssetAttribute] = useState([]);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [equipments, setEquipments] = useState([]);

  const [confirmModal, setConfirmModal] = useState(false);
  const [viewmodal, setViewModal] = useState(false);



  const [actionType, setActionType] = useState(null);
  const [actionEquipmentId, setActionEquipmentId] = useState(null);

  const [assets, setAssets] = useState([]);
  const [viewData, setviewdata] = useState([]);
  // const [formValues, setFormValues] = useState({});
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortBy, setSortBy] = useState({
    field: "created_at",
    order: "asc",
  });
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const startIndex = (page - 1) * pageSize + 1;
  const endIndex = Math.min(page * pageSize, totalItems);



  // const [assetAttributes, setAssetAttributes] = useState([]);

  const navigate = useNavigate();

  const [selectedAssetName, setSelectedAssetName] = useState("");





  const truncateText = (text, maxChars) => {
    if (text.length > maxChars) {
      return text.slice(0, maxChars) + "...";
    }
    return text;
  };

  const visibleColumns = assetAttribute.filter((field) => {
    return equipments.some(
      (equipment) =>
        equipment[field.field_name] !== undefined &&
        equipment[field.field_name] !== null
    );
  });

  // const handleInputChange = (e) => {
  // const { name, value, type, files } = e.target;
  // setFormValues((prevValues) => ({
  //   ...prevValues,
  //   [name]: type === "file" ? files[0] : value,
  // }));
  // };
  // const renderFormField = (attribute) => {
  //   switch (attribute.field_type) {
  //     case "string":
  //     case "number":
  //       return (
  //         <div
  //           key={attribute._id}
  //           className="col d-flex flex-column addEuipment-form-col"
  //         >
  //           <label
  //             htmlFor={attribute.field_name}
  //             className="addEuipment-form-text"
  //           >
  //             {attribute.display_name}
  //             {attribute.required && "*"}
  //           </label>
  //           <input
  //             required
  //             type={attribute.field_type}
  //             name={attribute.field_name}
  //             id={attribute.field_name}
  //             placeholder={`Enter the ${attribute.display_name.toLowerCase()}`}
  //             onChange={handleInputChange}
  //           />
  //         </div>
  //       );
  //     case "select":
  //       return (
  //         <div
  //           key={attribute._id}
  //           className="col d-flex flex-column addEuipment-form-col equipment-group"
  //         >
  //           <label
  //             htmlFor={attribute.field_name}
  //             className="addEuipment-form-text"
  //           >
  //             {attribute.display_name}
  //             {attribute.required && "*"}
  //           </label>
  //           <select
  //             required
  //             name={attribute.field_name}
  //             className="textarea"
  //             id={attribute.field_name}
  //             onChange={handleInputChange}
  //           >
  //             <option value="">Select {attribute.display_name}</option>
  //             {attribute.field_value.map((option, index) => (
  //               <option key={index} value={option}>
  //                 {option}
  //               </option>
  //             ))}
  //           </select>
  //         </div>
  //       );
  //     case "date":
  //       return (
  //         <div
  //           key={attribute._id}
  //           className="col d-flex flex-column addEuipment-form-col"
  //         >
  //           <label
  //             htmlFor={attribute.field_name}
  //             className="addEuipment-form-text"
  //           >
  //             {attribute.display_name}
  //             {attribute.required && "*"}
  //           </label>
  //           <input
  //             required
  //             type="date"
  //             name={attribute.field_name}
  //             id={attribute.field_name}
  //             onChange={handleInputChange}
  //           />
  //         </div>
  //       );
  //     case "textarea":
  //       return (
  //         <div
  //           key={attribute._id}
  //           className="col d-flex flex-column addEuipment-form-col"
  //         >
  //           <label
  //             htmlFor={attribute.field_name}
  //             className="addEuipment-form-text"
  //           >
  //             {attribute.display_name}
  //             {attribute.required && "*"}
  //           </label>
  //           <textarea
  //             required
  //             name={attribute.field_name}
  //             id={attribute.field_name}
  //             placeholder={`Enter the ${attribute.display_name.toLowerCase()}`}
  //             onChange={handleInputChange}
  //           />
  //         </div>
  //       );
  //     case "file":
  //       return (
  //         <div
  //           key={attribute._id}
  //           className="col d-flex flex-column addEuipment-form-col"
  //         >
  //           <label
  //             htmlFor={attribute.field_name}
  //             className="addEuipment-form-text"
  //           >
  //             {attribute.display_name}
  //             {attribute.required && "*"}
  //           </label>
  //           <input
  //             required
  //             type="file"
  //             name={attribute.field_name}
  //             id={attribute.field_name}
  //             onChange={handleInputChange}
  //           />
  //         </div>
  //       );
  //     default:
  //       return null;
  //   }
  // };
  // const filteredColumns = dynamicColumns.filter(
  //   (column) => !excludedColumns.includes(column)
  // );

  const updateDynamicColumns = (data) => {
    if (data.length > 0) {
      // const columns = Object.keys(data[0]);
      // setDynamicColumns(columns);
    }
  };

  useEffect(() => {
    const getAssetClass = async () => {
      try {
        const data = await fetchWrapper(
          `${process.env.REACT_APP_BASE_API_URL1}/api/v1/asset/getall`,
          {
            method: "POST",
            body: JSON.stringify({}),
          }
        );

        setAssets(data || []);
        setFilteredAssets(data || []); // Set both assets and filteredAssets initially
      } catch (error) {
        console.error("Error fetching data:", error.message);
        if (error.message === "Unauthorized") {
          navigate("/auth/login");
        }
      }
    };

    getAssetClass();
  }, [navigate]);

  const handleChange = (e) => {

    const value = e.target.value;
    fetchEquipments(value); // Fetch data based on the selected value
    setDeleteid(value);
    // alert(deleteid) // Update the state for deleteId
  };

  const fetchEquipments = async (asset_id1) => {
    try {
      setAsset_Id(asset_id1);
      const queryString = `?page=${page}&limit=${pageSize}&sortBy=${sortBy.field}&order=${sortBy.order}&search=${search}`;
      const apiUrl = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipment/${asset_id1}/paginate${queryString}`;



      const data = await fetchWrapper(
        apiUrl,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}), // Add an empty body if required by your API
        },
        navigate
      );

      // Directly use the data without checking response.ok again

      updateDynamicColumns(data.equipments);
      setAssetAttribute(data.assetAttribute);

      setEquipments(data.equipments);
      setTotalPages(data.totalPages);
      setTotalItems(data.totalItems);
      setCurrentPage(data.currentPage);

    } catch (error) {
      updateDynamicColumns("")

      setAssetAttribute([])

      setEquipments(([]));
      setTotalPages(0);
      setTotalItems(0);
      setCurrentPage(1);
      console.error("Error fetching equipments:", error);
    }
  };





  const handleEquipmentDeleteRestore = (equipmentId, currentStatus) => {
    setActionEquipmentId(equipmentId);
    setActionType(currentStatus ? "Delete" : "Delete");
    setConfirmModal(true);
  };

  const handleview = async (equipmentId) => {
    setLoading(true);
    setViewModal(true);
    try {
      const data = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipments/preview/${equipmentId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}), // Add an empty body if required by your API
        },
        navigate
      );

      // Directly use the data received from fetchWrapper
      setviewdata(data.data || []);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      if (error.message === "Unauthorized") {
        navigate("/auth/login");
      }
    }
  };

  const confirmAction = () => {
    setLoading(true);
    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipment/delete/${actionEquipmentId}`;


    fetchWrapper(
      url,
      {
        method: "POST",
      },
      navigate
    )
      .then(() => {
        setLoading(false);

        // Update the status of the equipment
        const updatedEquipments = equipments.map((equipment) =>
          equipment._id === actionEquipmentId
            ? { ...equipment, status: actionType === "Delete" ? true : true }
            : equipment
        );
        fetchEquipments(deleteid);
        setEquipments(updatedEquipments);
        setConfirmModal(false);
        toast.success(`Equipment ${actionType} successful`);
        dispatch(fetchMenuItems());
      })
      .catch((error) => {
        console.error(`Error ${actionType} equipment:`, error);
        toast.error(`Error while  ${actionType} equipment`);
      });
  };

  const downloadEquipment = async (equipmentId, name) => {
    setLoading(true);
    try {
      const response = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipment/${equipmentId}/download/json`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        },
        navigate,
        true // Request the raw response
      );

      // Process the raw response as a blob
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `equipment_${name}.json`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setLoading(false);
      if (error.message === "Unauthorized") {
        navigate("/auth/login");
        setLoading(false);
      }
    }
  };

  const downloadymlequipment = async (equipmentId, name) => {


    // alert(name);
    setLoading(true);
    try {
      const response = await fetchWrapper(
        // `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipment/${equipmentId}/download/yml`,
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipments/review/properties/equipment/${equipmentId}/download/yml`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        },
        navigate,
        true // Request the raw response
      );

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `equipment_${name}.yml`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      setLoading(false);

      // Manually hide the tooltip
      if (buttonRef.current) {
        const tooltipInstance = bootstrap.Tooltip.getInstance(
          buttonRef.current
        );
        if (tooltipInstance) {
          tooltipInstance.hide();
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setLoading(false);
      if (error.message === "Unauthorized") {
        navigate("/auth/login");
        setLoading(false);
      }
    }
  };

  const downloadyml = async (equipmentId, name) => {
    // alert(name);
    setLoading(true);
    try {
      const response = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipment/${equipmentId}/download/yml`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({}),
        },
        navigate,
        true // Request the raw response
      );

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `equipment_${name}.yml`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      setLoading(false);

      // Manually hide the tooltip
      if (buttonRef.current) {
        const tooltipInstance = bootstrap.Tooltip.getInstance(
          buttonRef.current
        );
        if (tooltipInstance) {
          tooltipInstance.hide();
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setLoading(false);
      if (error.message === "Unauthorized") {
        navigate("/auth/login");
        setLoading(false);
      }
    }
  };


  const handleSortChange = (field) => {
    setSortBy((prevSort) => ({
      field,
      order:
        prevSort.field === field && prevSort.order === "asc" ? "desc" : "asc",
    }));
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);

    setPage(1);
  };



  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  const handlePageSizeChange = (size) => {
    setPageSize(size);

    setPage(1);
  };

  const handleOptionClick = (assetId, assetName) => {
    setSelectedAssetName(assetName);
    setIsOpen(false);
    handleChange({ target: { value: assetId } });
  };

  const handleSearchChange1 = (event) => {
    const value = event.target.value;
    setSearchQuery(value);
    if (!value) {
      setFilteredAssets(assets); // Reset to all assets if search is cleared
    } else {
      const filtered = assets.filter((asset) =>
        asset.asset_name.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredAssets(filtered);
    }
  };

  const toggleDropdown1 = () => {
    setSearchQuery("");
    setIsOpen(!isOpen);
    if (!isOpen) {
      setTimeout(() => {
        searchInputRef.current.focus();
      }, 0);
    }
  };
  useEffect(() => {
    if (isOpen) {
      handleSearchChange1({ target: { value: searchQuery } });
    }
  }, [isOpen]);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  // Handle outside clicks to close dropdown
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);




  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior if needed
      fetchEquipments(asset_id); // Perform search
    }
  };

  useEffect(() => {
    if (asset_id) {
      fetchEquipments(asset_id);
    }
  }, [
    page,
    pageSize,
    sortBy,
    // search,
    totalPages,
    currentPage,

    equipments.length,
  ]);

  // const groupedItems = [];
  // for (let i = 0; i < assetAttributes.length; i += 2) {
  //   groupedItems.push(assetAttributes.slice(i, i + 2));
  // }
  useEffect(() => {
    const tooltipTriggerList = document.querySelectorAll(
      '[data-bs-toggle="tooltip"]'
    );
    const tooltipList = [...tooltipTriggerList].map(
      (tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl)
    );
    return () => {
      tooltipList.forEach((tooltip) => tooltip.dispose());
    };
  }, [tooltipid]);
  const downloadExcel = async () => {
    console.log(asset_id)
    setLoading(true);
    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/equipment/exceldownoload`;

    try {
      const response = await fetchWrapper(
        url,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ asset_id }) // Include asset_id in the request body
        },
        navigate,
        true
      ); // Pass rawResponse as true to get the raw response

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob(); // Get the blob from the response
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = `master-${assetname}.xlsx`; // Specify the file name here
      document.body.appendChild(a);
      a.click();
      a.remove();

      setLoading(false);
      toast.success(`Download Excel Successful`);
    } catch (error) {
      setLoading(false);
      console.error(`Error downloading Excel:`, error);
      toast.error(`Failed to download Excel: ${error.message}`);
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <div className="">
          <div className="container">
            <div className="pt-3 pb-0 d-flex justify-content-between">
              <div className="">
                <h5>All Assets</h5>

                <nav className="breadcrumb-nav" aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="#" style={{ textDecoration: "none" }}>
                        My Assets
                      </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      All Assets
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
            <div className="">
              <div
                className="navbar-3 d-flex justify-content-between"
                style={{ marginTop: "-3px" }}
              >
                <div className="d-flex gap-3">

                  {asset_id && totalItems >= 1 ? (
                    <div className="search-container ">
                      <img src={search2} alt="Search" />
                      <input
                        type="text"
                        className=""
                        id="search"
                        value={search}
                        onChange={handleSearchChange}
                        onKeyDown={handleKeyDown}
                        placeholder="Search"
                        name="search"
                        autoComplete="off"
                      />
                    </div>
                  ) : null}

                </div>
                <div className="d-flex gap-3">
                  <div className="dropdown" style={{ position: "relative" }}>
                    <input
                      id="cars"
                      style={{
                        height: "48px",

                        borderRadius: "12px",
                      }}
                      type="text"
                      className="form-control input_dropdown"
                      onClick={toggleDropdown1}
                      placeholder="Select Asset Class"
                      value={selectedAssetName}
                    // readOnly
                    />
                    {isOpen && (
                      <div
                        ref={dropdownRef}
                        className="dropdown-menu"
                        style={{
                          // marginTop: "-2px",
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          width: "100%",
                          marginTop: "2px",
                          maxHeight: "250px",
                          padding: "2px",
                          lineHeight: "15px",
                          overflowY: "auto",
                          borderRadius: "6px",
                          backgroundColor: "white",
                          // border: "1px solid #ccc",

                          zIndex: 1000,
                          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
                          display: "block",
                        }}
                      >
                        <input
                          type="text"
                          className="searchBox"
                          placeholder="Search..."
                          value={searchQuery}
                          onChange={handleSearchChange1}
                          ref={searchInputRef}
                          style={{
                            padding: "10px",
                            width: "100%",
                            lineHeight: "15px",
                            border: "1px solid #CED4DA", // Set the initial border style
                            outline: "none", // Remove default focus outline
                          }}
                          onFocus={(e) => {
                            e.target.style.border = "1px solid #CED4DA"; // Change to desired focus border color
                          }}
                          onBlur={(e) => {
                            e.target.style.border = "1px solid #CED4DA"; // Revert to initial border color when focus is lost
                          }}
                        />
                        <ul style={{ listStyleType: "none", padding: 0 }}>
                          {filteredAssets.map((asset) => (
                            <li
                              key={asset._id}
                              onClick={() => {
                                setAssetname(asset.asset_name)
                                handleOptionClick(asset._id, asset.asset_name); // Your existing handler
                                handleChange({ target: { value: asset._id } }); // Call handleChange with a simulated event
                              }}
                              style={{
                                padding: "8px",
                                cursor: "pointer",
                                // borderBottom: "1px solid #ccc",
                              }}
                            >
                              {asset.asset_name}
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                  <div>
                    {asset_id && totalItems >= 1 ? (
                      <div>
                        <button
                          type="button"
                          id="openPopup"
                          className="btn-bg"
                          onClick={() => downloadExcel()}
                        >
                          <span className="plus-icon">
                            <img
                              style={{ width: "25px" }}
                              src={downloadwhite}
                              alt="Download"
                            />
                          </span>
                          Download
                        </button>
                      </div>
                    ) : null}
                  </div>

                  {hasPermission(["myAssets.create"]) && (
                    <div>
                      <button
                        type="button"
                        id="openPopup"
                        className="btn-bg"
                        onClick={() => navigate(`/add_equipment`)}
                      >
                        <span className="plus-icon">
                          <img src={plus1} alt="Plus Icon" />
                        </span>
                        ADD EQUIPMENT
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div style={{ marginTop: "-10px" }}>
                <div className="table-responsive">
                  <table className="table  align-middle table-text">
                    <thead className="table-head align-middle">
                      <tr>
                        <th className="col">ID</th>
                        {visibleColumns.map((field, index) => (
                          <th
                            className="col text-uppercase"
                            key={index}
                            onClick={() => handleSortChange(field.field_name)}
                          >
                            <span>
                              {field.display_name}{" "}
                              {sortBy.field === field.field_name && (
                                <span>
                                  {sortBy.order === "asc" ? (
                                    <img src={ArrowUp} alt="Ascending" />
                                  ) : (
                                    <img src={ArrowDown} alt="Descending" />
                                  )}
                                </span>
                              )}
                            </span>
                          </th>
                        ))}

                        <th className="col-3 text-center">ACTION</th>
                      </tr>
                    </thead>
                    <tbody>
                      {equipments.map((equipment, index) => (
                        <tr
                          key={equipment._id}
                        // className={
                        //   equipment.status ? "" : "disabled text-muted"
                        // }
                        >
                          {/* <td className="table-check">
                        <input
                          type="checkbox"
                          checked={checkedItems.includes(equipment._id)}
                          onChange={() =>
                            handleRowCheckboxChange(equipment._id)
                          }
                          disabled={!equipment.status}
                        />
                      </td> */}
                          <td className="col " >{index + startIndex}</td>
                          {visibleColumns.map((field, cellIndex) => (
                            <td key={cellIndex}>
                              {equipment[field.field_name] !== undefined &&
                                equipment[field.field_name] !== null ? (
                                <span title={equipment[field.field_name]}>
                                  {truncateText(
                                    equipment[field.field_name],
                                    15
                                  )}
                                </span>
                              ) : null}
                            </td>
                          ))}
                          <td className="text-center">
                            <div className="action-icons">
                              {hasPermission(["myAssets.download"]) && (
                                <button
                                  ref={buttonRef}
                                  style={{
                                    border: "none",
                                    backgroundColor: "transparent",
                                  }}
                                  className="align-content-center me-3 mt-1"
                                  onClick={() =>
                                    downloadymlequipment(
                                      equipment._id,
                                      equipment.equipment_code
                                      , equipment
                                    )
                                  }
                                  onMouseEnter={() => setTooltipid(equipment._id)}
                                  title="Download YML file"
                                >
                                  <img
                                    style={{ width: "25px" }}
                                    src={Compactyml}
                                    alt="Run Assessment"
                                  />
                                </button>
                              )}

                              {hasPermission(["myAssets.download"]) && (
                                <button
                                  ref={buttonRef}
                                  style={{
                                    border: "none",
                                    backgroundColor: "transparent",
                                  }}
                                  className="align-content-center me-3 mt-1"
                                  onClick={() =>
                                    downloadyml(
                                      equipment._id,
                                      equipment.equipment_code
                                    )
                                  }
                                  onMouseEnter={() => setTooltipid(equipment._id)}
                                  title="Download YML file"
                                >
                                  <img
                                    style={{ width: "25px" }}
                                    src={btn3}
                                    alt="Run Assessment"
                                  />
                                </button>
                              )}
                              {hasPermission(["myAssets.download"]) && (
                                <button
                                  style={{
                                    border: "none",
                                    backgroundColor: "transparent",
                                  }}
                                  className="align-content-center me-3 mt-1"
                                  onClick={() =>
                                    downloadEquipment(
                                      equipment._id,
                                      equipment.equipment_code
                                    )
                                  }
                                  title="Download JSON file"
                                  onMouseEnter={() => setTooltipid(equipment._id)}
                                >
                                  <img
                                    style={{ width: "25px" }}
                                    src={download}
                                    alt="Download"
                                  />
                                </button>
                              )}
                              {hasPermission(["myAssets.view"]) && (
                                <button
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                  }}
                                  className="align-content-center me-3 mt-1"
                                  onClick={() => handleview(equipment._id)}
                                  title="View"
                                  onMouseEnter={() => setTooltipid(equipment._id)}
                                >
                                  <img
                                    style={{ width: "25px" }}
                                    src={visible}
                                    alt="visible"
                                  />
                                </button>
                              )}
                              {hasPermission(["myAssets.update"]) && (
                                <button
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                  }}
                                  className="align-content-center me-3 mt-1"
                                  onClick={() =>
                                    navigate(`/edit_equipment/${equipment._id}`)
                                  }
                                  title="Edit"
                                  onMouseEnter={() =>
                                    setTooltipid(equipment._id)
                                  }
                                >
                                  <img
                                    style={{ width: "25px" }}
                                    src={edit}
                                    alt="edit"
                                  />
                                </button>
                              )}
                              {hasPermission(["myAssets.delete"]) && (
                                <button
                                  style={{
                                    border: "none",
                                    background: "transparent",
                                  }}
                                  className="align-content-center me-3 mt-1"
                                  onClick={() =>
                                    handleEquipmentDeleteRestore(equipment._id)
                                  }
                                  title="Delete"
                                  onMouseEnter={() =>
                                    setTooltipid(equipment._id)
                                  }
                                >
                                  <img
                                    style={{ width: "25px" }}
                                    src={trash}
                                    alt="Delete"
                                  />
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                pageSize={pageSize}
                onPageSizeChange={handlePageSizeChange}
                totalItems={totalItems}
                startIndex={startIndex}
                endIndex={endIndex}
              />
              {/* Confirmation Modal Content */}
              <div
                id="overlay"
                className={`modal fade ${confirmModal ? "show" : ""}`}
                tabIndex="-1"
                role="dialog"
                style={{
                  zIndex: 30,
                  display: confirmModal ? "block" : "none",
                  transition: "width 2s",
                }}
              >
                {loading ? (
                  <Loader />
                ) : (
                  <div>
                    <div className="addunit-card Width 25%">
                      <div className="addunit-header">
                        <h4 className="modal-title">
                          {actionType === "restore" ? "Restore " : "Delete "}{" "}
                          Asset
                        </h4>
                        <button
                          style={{ border: "none", backgroundColor: "inherit" }}
                          type="button"
                          className="close"
                          onClick={() => setConfirmModal(false)}
                        >
                          <img
                            src={close}
                            width="28px"
                            height="28px"
                            alt="Close"
                          />
                        </button>
                      </div>
                      <div className="addunit-form">
                        <p>
                          Are you sure you want to{" "}
                          {actionType === "restore" ? "restore" : "delete"} this
                          equipment?
                        </p>
                      </div>
                      <div className="addunit-card-footer justify-content-between">
                        <button
                          type="button"
                          className="discard-btn"
                          onClick={() => setConfirmModal(false)}
                        >
                          Cancel
                        </button>
                        <button
                          type="button"
                          className="update-btn"
                          onClick={confirmAction}
                        >
                          {actionType === "restore" ? "Restore" : "Delete"}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>

              {/* View Modal Content */}
              <div
                id="overlay"
                className={`modal fade ${viewmodal ? "show" : ""}`}
                tabIndex="-1"
                role="dialog"
                style={{
                  zIndex: 30,
                  display: viewmodal ? "block" : "none",
                  transition: "width 2s",
                }}
              >
                {loading ? (
                  <Loader />
                ) : (
                  <div
                    className="addunit-card"
                    style={{
                      width: "50%",
                      height: "80%",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <div className="addunit-header">
                      <h4 className="modal-title">View Asset</h4>
                      <button
                        style={{ border: "none", backgroundColor: "inherit" }}
                        type="button"
                        className="close"
                        onClick={() => setViewModal(false)}
                      >
                        <img
                          src={close}
                          width="28px"
                          height="28px"
                          alt="Close"
                        />
                      </button>
                    </div>
                    <div
                      className="addunit-form"
                      style={{
                        flex: "1 1 auto",
                        overflowY: "auto",
                        marginBottom: "10px", // Adjust as needed for spacing
                      }}
                    >
                      {/* Use a pre tag to format JSON in a readable way */}
                      <pre>{JSON.stringify(viewData, null, 2)}</pre>
                    </div>
                    <div
                      className="addunit-card-footer justify-content-between"
                      style={{ flexShrink: 0 }}
                    >
                      <button
                        type="button"
                        className="discard-btn"
                        onClick={() => setViewModal(false)}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
          />
        </div>
      )}
    </>
  );
};

export default AllAssets;
